import React, { useState } from "react";
import LoginForm from "./LoginForm";
import Chart_Image from "../assets/Analytics_Dashboard.png";
import { Switch, Typography } from "antd";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";

function Login() {
  const [darkMode, setDarkMode] = useState(false);
  const { Text } = Typography;

  return (
    <div className="min-h-screen flex">
      {/* LEFT SIDE (IMAGE) */}
      <div
        className={`w-1/2 hidden md:flex items-center justify-center p-10 ${
          darkMode
            ? "bg-gray-900"
            : "bg-gradient-to-br from-blue-900 to-blue-600"
        }`}
      >
        <img
          src={Chart_Image}
          alt="Analytics"
          className="max-w-full h-auto rounded-xl shadow-2xl"
        />
      </div>

      {/* RIGHT SIDE (LOGIN) */}
      <div className="w-full md:w-1/2 flex items-center justify-center bg-white relative px-6">
        {/* Background dots */}
        <div className="absolute inset-0 opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage:
                "radial-gradient(circle at 1px 1px, #3b82f6 1px, transparent 0)",
              backgroundSize: "20px 20px",
            }}
          />
        </div>

        <div className="w-full max-w-md relative z-10">
          {/* LOGIN FORM */}
          <LoginForm />
        </div>
      </div>
    </div>
  );
}

export default Login;
